import {StyleSheet} from 'react-native';

const cardPadding = 24;

export const styles = StyleSheet.create({
  trainerBox: {},
});
